import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full h-full items-center justify-center" }
const _hoisted_2 = { class: "flex flex-row space-x-8 px-5" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col space-y-5 py-6" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-24px font-bold text-black-lp-300" }, [
    /*#__PURE__*/_createTextVNode(" Oops... Nomor STT Salah"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("atau Tidak Ditemukan ")
  ]),
  /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-600" }, [
    /*#__PURE__*/_createTextVNode(" Halaman yang Anda cari tidak ditemukan. Silahkan kembali ke"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("halaman awal atau hubungin kami di "),
    /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 underline" }, "customer.care@lionparcel.com")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: require('@/app/ui/assets/svg/spot-404.svg'),
        alt: "404",
        style: {"width":"224px"}
      }, null, 8, ["src"]),
      _hoisted_3
    ])
  ]))
}